import type { TelemetryNote } from "@/types";

interface TimelineNoteMarkersProps {
  notes: TelemetryNote[];
  /** Maps a note to its position on the timeline in session-time seconds. */
  getSessionTime: (note: TelemetryNote) => number;
  /** Maps session time to a CSS `left` percentage string. */
  getPointPosition: (sessionTime: number) => string;
  buildAriaLabel: (note: TelemetryNote, sessionTime: number) => string;
  onNoteClick?: (note: TelemetryNote) => void;
}

/** Purple-diamond note markers shared by the video timelines. */
export function TimelineNoteMarkers({
  notes,
  getSessionTime,
  getPointPosition,
  buildAriaLabel,
  onNoteClick,
}: TimelineNoteMarkersProps) {
  return (
    <>
      {notes.map((note) => {
        const sessionTime = getSessionTime(note);
        return (
          <button
            key={note.id}
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              onNoteClick?.(note);
            }}
            className="pointer-events-auto absolute top-2 z-20 h-3 w-3 -translate-x-1/2 rotate-45 rounded-[3px] border border-[#c084fc] bg-[#4c1d95] shadow-[0_0_5px_rgba(168,85,247,0.55)]"
            style={{ left: getPointPosition(sessionTime) }}
            title={note.content}
            aria-label={buildAriaLabel(note, sessionTime)}
          />
        );
      })}
    </>
  );
}
